import React, { useEffect, useState } from 'react';
import { LoadingIcon } from './LoadingIcon';

export function DeferredLoadingIcon({ wait = 1000, ...props }) {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const timeout = setTimeout(() => setIsVisible(true), wait);
    return () => {
      clearTimeout(timeout);
    };
  }, []);

  return isVisible ? <LoadingIcon {...props} /> : null;
}
